module.exports = __webpack_public_path__ + "img/motorcycle_disabled2.edc6eb3b.svg";